export type CatalogFilter = 'all' | 'owned' | 'public' | 'private' | 'archived';

const STORAGE_KEY = 'cdp_catalog_filters';
const FILTERS = new Set<CatalogFilter>(['all', 'owned', 'public', 'private', 'archived']);
const DEFAULT_FILTERS: CatalogFilter[] = ['owned'];

export function readCatalogFilters(userId: string): CatalogFilter[] {
  try {
    const stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY) ?? '') as {
      userId?: unknown;
      filters?: unknown;
    };
    if (stored.userId !== userId || !Array.isArray(stored.filters)) return DEFAULT_FILTERS;

    const filters = stored.filters.filter(
      (filter): filter is CatalogFilter => typeof filter === 'string' && FILTERS.has(filter as CatalogFilter),
    );
    const unique = [...new Set(filters)];
    return unique.includes('all')
      ? ['all', ...unique.filter(filter => filter === 'archived')]
      : unique;
  } catch {
    return DEFAULT_FILTERS;
  }
}

export function writeCatalogFilters(userId: string, filters: CatalogFilter[]): void {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ userId, filters }));
}

export function clearCatalogFilters(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}
